import _uniqueId from "lodash/uniqueId";
import * as types from '../types';
const checkExerciseCompleted = (id, success, message) => ({
  id,
  message,
  messageId: _uniqueId(),
  success,
  type: types.CHECK_EXERCISE_COMPLETED
});
export default checkExerciseCompleted;